import z from "zod";

/** Available AI chat modes. */
export const ChatModeSchema = z.enum(["AUTO", "PLAN", "DASHBOARD", "ASK"]);
export type ChatMode = z.infer<typeof ChatModeSchema>;
